import { render, staticRenderFns } from "./Tipomacchina.vue?vue&type=template&id=38182292&scoped=true&"
import script from "./Tipomacchina.vue?vue&type=script&lang=js&"
export * from "./Tipomacchina.vue?vue&type=script&lang=js&"
import style0 from "./Tipomacchina.vue?vue&type=style&index=0&id=38182292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38182292",
  null
  
)

export default component.exports